import React from 'react';
import { SpinningCircles  } from 'react-loading-icons';

const Loader = () => (
  <div className="site--loader pt-10 position-absolute sticky-top w-100 t-0 h-100 d-flex justify-content-center align-items-center">
      <SpinningCircles  fill="#b97a56" stroke="#b97a56" height={80} />
  </div>
);

export default Loader;